<template>
    <el-dialog :visible="visible" @close="closeHandler" top="10vh" width="1000px" class="person-info-dialog">
        <div v-loading="isLoad" class="person-all-info">
            <el-collapse v-model="expanded">
                <el-collapse-item name="1">
                    <template v-slot:title>
                        <div class="info-title">个人信息</div>
                    </template>
                    <template>
                        <table class="el-table">
                            <thead>
                                <tr>
                                    <th>姓名</th>
                                    <th>性别</th>
                                    <th>出生日期</th>
                                    <th>出生地</th>
                                    <th>身份证号码</th>
                                    <th>单位名称</th>
                                    <th>职务</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td @click="getPersonDetail" style="color: #409EFF; cursor: pointer;">{{ personInfo.name }}</td>
                                    <td>{{ personInfo.sex }}</td>
                                    <td>{{ personInfo.birthday }}</td>
                                    <td>{{ personInfo.placeBirth }}</td>
                                    <td>{{ personInfo.cartNo }}</td>
                                    <td>{{ personInfo.workUnit }}</td>
                                    <td>{{ personInfo.duty }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template v-slot:title>
                        <div class="info-title">证照信息({{ cardList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="cardList">
                            <el-table-column label="证照号码" prop="cerNumber">
                                <template v-slot="{ row }">
                                    <el-button type="text">
                                        <router-link target="_blank"
                                            :to="{ path: '/foreign_licence_manage/system_licence_manage', query: { cerNumber: row.cerNumber } }">
                                            {{ row.cerNumber }}</router-link>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="证照类型" prop="cerType"></el-table-column>
                            <el-table-column label="发照日期" prop="issueDate"></el-table-column>
                            <el-table-column label="有效期" prop="validDate"></el-table-column>
                            <el-table-column label="状态" prop="cerStatus"></el-table-column>
                            <el-table-column label="扫描件" min-width="50px">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" v-if="scope.row.scanningCopy" @click="previewHandler(scope.row,'cer')"><i class="el-icon-view"></i></el-button>
                                    <span v-else>---</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="3">
                    <template v-slot:title>
                        <div class="info-title">采集信息({{ collectInfo }}条)</div>
                    </template>
                    <slot name="passport"></slot>
                </el-collapse-item>
                <el-collapse-item name="4">
                    <template v-slot:title>
                        <div class="info-title">立项信息({{ itemList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="itemList">
                            <el-table-column label="团组名称" prop="teamName" width="240px">
                                <template v-slot="{ row }">
                                    <el-button type="text">
                                        <router-link :title="row.teamName" target="_blank"
                                            :to="{ path: '/set_up/group_info', query: { id: row.itemInfoId, type: 'detail' } }">
                                            {{ row.teamName }}</router-link>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="批件号" >
                                <template v-slot="{row}">
                                    <el-button type="text" @click="jumpPdf(row.itemInfoId)">{{row.receiveNo}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="在外天数" prop="outsideNum"></el-table-column>
                            <el-table-column label="启程日期" prop="preDepaDate"></el-table-column>
                            <el-table-column label="申报单位" prop="tuxUnitName"></el-table-column>
                            <el-table-column label="当前状态" prop="statusName"></el-table-column>
                            <el-table-column label="成行情况" prop="travelFlag">
                                <template v-slot="{ row }">
                                    <el-button type="text" @click="handleTravel(row)">
                                        {{ row.travelFlag == "Y" ? "已成行" : row.travelFlag == "N" ? "未成行" : "-" }}
                                    </el-button>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="国家">
                                <template v-slot="{ row }">
                                    <div>
                                        <router-link target="_blank"
                                            :to="{ path: '/set_up/group_info', query: { id: row.itemInfoId, type: 'detail' } }">
                                            {{ row.visitCountryName }}</router-link>
                                    </div>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="5">
                    <template v-slot:title>
                        <div class="info-title">出境证信息({{ certList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="certList">
                            <el-table-column label="出访国家(地区)" prop="overCountry">
                                <template v-slot="{ row }">
                                    <el-button type="text">
                                        <!-- <span @click="jump">{{row.overCountry}}</span> -->
                                        <router-link target="_blank"
                                            :to="{ path: isAffairs ? '/apply_exit/apply_cert_list' : '/set_up/company_setup', query: { itemInfoId: row.itemInfoId, typeMode: isAffairs ? 'all' : '' } }">
                                            {{ row.overCountry }}</router-link>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="任务类型" prop="taskDesk"></el-table-column>
                            <el-table-column label="出境证类型" prop="visaValidity"></el-table-column>
                            <el-table-column label="签证(注)情况" prop="singType"></el-table-column>
                            <el-table-column label="出境证号" min-width="130px" prop="groupBatchNo" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="6">
                    <template v-slot:title>
                        <div class="info-title">签证(注)信息({{ visaList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="visaList">
                            <el-table-column label="证件号码" prop="certNo">
                                <template v-slot="{ row }">
                                    <el-button type="text">
                                        <router-link target="_blank"
                                            :to="{ path: '/foreign_licence_manage/visa_management', query: { certNo: row.certNo } }">
                                            {{ row.certNo }}</router-link>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="证照类型" prop="type"></el-table-column>
                            <!-- prop="visaCountryName" -->
                            <el-table-column label="国家">
                                <template v-slot="{ row }">
                                    <el-button type="text">
                                        <router-link target="_blank"
                                            :to="{ path: '/foreign_licence_manage/visa_management', query: { visaCountryName: row.visaCountryName, personInfoId: row.personInfoId } }">
                                            {{ row.visaCountryName }}</router-link>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="费用" prop="cost"></el-table-column>
                            <el-table-column label="登记时间" prop="createTime"></el-table-column>
                            <el-table-column label="取走时间" prop="issueTime"></el-table-column>
                            <el-table-column label="扫描件" min-width="50px">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" v-if="scope.row.scanningCopy" @click="previewHandler(scope.row,'vist')"><i class="el-icon-view"></i></el-button>
                                    <span v-else>---</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" prop="remark"></el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="reject">
                    <template v-slot:title>
                        <div class="info-title">签证(注)拒签信息({{ rejectList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="rejectList">
                            <!-- <el-table-column label="团组名称" prop="teamName">
                <template v-slot="{row}">
                  <el-button type="text">
                    <router-link
                      target="_blank"
                      :to="{path:'/set_up/group_info',query:{type:'detail',id:row.itemInfoId}}"
                    >{{row.teamName}}</router-link>
                  </el-button>
                </template>
              </el-table-column> -->
                            <el-table-column label="申请国家(地区)" prop="visaCountryName"></el-table-column>
                            <el-table-column label="拒签原因" prop="remark"></el-table-column>
                            <el-table-column label="创建时间" prop="createTime"></el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="7">
                    <template v-slot:title>
                        <div class="info-title">境外换发信息({{ exchangeList.length }}条)


                            {{ componentsName === 'a' ? '1' : '' }}
                        </div>
                    </template>
                    <template>
                        <el-table :data="exchangeList">
                            <!-- <el-table-column label="团组名称" prop="teamName">
                <template v-slot="{row}">
                  <el-button type="text">
                    <router-link
                      target="_blank"
                      :to="{path:'/exchange/company_exchange',query:{id:row.renewalId}}"
                    >{{row.teamName}}</router-link>
                  </el-button>
                </template>
              </el-table-column> -->
                            <el-table-column label="申报单位" prop="companyName"></el-table-column>
                            <el-table-column label="收文编号" prop="receiveNo"></el-table-column>
                            <el-table-column label="最后操作时间" prop="updateTime"></el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
                <el-collapse-item name="8">
                    <template v-slot:title>
                        <div class="info-title">注销护照信息({{ destroyList.length }}条)</div>
                    </template>
                    <template>
                        <el-table :data="destroyList">
                            <!-- <el-table-column label="团组名称" prop="teamName">
                <template v-slot="{row}">
                  <el-button type="text">
                    <router-link
                      target="_blank"
                      :to="{path:'/exchange/company_cancel',query:{id:row.destroyId}}"
                    >{{row.teamName}}</router-link>
                  </el-button>
                </template>
              </el-table-column> -->
                            <el-table-column label="申报单位" prop="companyName"></el-table-column>
                            <el-table-column label="注销护照号" prop="passportNo"></el-table-column>
                            <el-table-column label="收文编号" prop="receiveNo"></el-table-column>
                            <el-table-column label="最后操作时间" prop="updateTime"></el-table-column>
                        </el-table>
                    </template>
                </el-collapse-item>
            </el-collapse>
        </div>
        <travel-dialog :visible.sync="vis_travel" :visit-id="visitId" body :personInfoId="personInfoId" @close="closeTravel" :showTravelFlag="true"></travel-dialog>
        <rotatable-img :visible.sync="img_visible" :imgUrl="imgUrl" @close="closeRotatable"></rotatable-img>
    </el-dialog>
</template>
<script>
import PersonManage from "@/api/setup/personManage.js";
import { mapGetters } from "vuex";
import UserLogin from "@/api/LoginApi.js";
let LoginApi = new UserLogin();
let Api = new PersonManage();
export default {
    props: ["visible", "personInfoId", "componentsName"],
    data() {
        return {
            imgUrl: '',
            img_visible: false,
            expanded: ["1"],
            personInfo: {},
            cardList: [],
            itemList: [],
            certList: [],
            visaList: [],
            portList: [],
            exchangeList: [],
            rejectList: [],
            destroyList: [],
            isLoad: false,
            vis_travel: false,
            visitId: "",
            collectInfo: null,
            isAffairs: false,//判断是否是外事办的员工
        };
    },
    computed: {
        ...mapGetters(["token"])
    },
    components: {
        travelDialog: () => import("./travel_dialog.vue")
    },
    methods: {
        //跳转到人员基本信息页面
        getPersonDetail() {
            if(!this.personInfoId) return
            window.open(`/set_up/person_form?id=${this.personInfoId}`); //跳转打开编辑人员新窗口
        },
        jumpPdf(id){
            window.open(
                "/share-foreign/visa/stateItemInfo/getBatchFile?itemInfoId=" +
                id +
                "&token=" +
                this.token,
                "_blank"
            );
        },
        async previewHandler(row,type){
            this.img_visible = true;
            this.imgUrl = `/share-foreign/commannex/viewAnnex?path=${row.scanningCopy}&token=${this.token}`;
        },
        // 关闭图片预览
        closeRotatable() {
          this.img_visible = false;
          this.imgUrl = '';
        },
        getData() {
            this.isLoad = true;
            Api.allInfo({ personInfoId: this.personInfoId })
                .then(res => {
                    this.personInfo = res.data.personInfo;
                    this.cardList = res.data.certInfo;
                    this.itemList = res.data.itemInfo;
                    this.certList = res.data.exitCertInfo;
                    this.visaList = res.data.visaInfo;
                    this.exchangeList = res.data.renewalInfo;
                    this.destroyList = res.data.destroyInfo;
                    this.rejectList = res.data.visaFailure;
                    this.isLoad = false;
                    this.collectInfo = res.data.collectInfo;
                })
                .catch(e => {
                    this.isLoad = false;
                });
        },
        closeHandler() {
            this.expanded = ["1"];
            this.$emit("close");
            this.$emit("update:visible", false);
        },
        handleTravel(row) {
            this.visitId = row.itemInfoId
            this.vis_travel = true
        },
        closeTravel() {
          this.visitId = '';
          this.vis_travel = false;
        },
    },
    watch: {
        visible: function (v) {
            if (v) {
                this.getData();
            }
        }
    },
    mounted() {
        if (this.personInfoId) {
            this.getData();
        };
        LoginApi.getUserInfo({}).then((res) => {
            let dept = res.data.userDept;
            this.isAffairs = dept.some(item => item.deptId == '1855060454393745409');
        })
    }
};
</script>
<style lang="scss" scoped>
.info-title {
    color: #fff;
    font-size: 16px;
    padding-left: 15px;
}

.person-info-dialog {
    /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: black;
    }
}

.person-all-info {
    padding-top: 10px;

    /deep/ .el-collapse-item__content {
        padding: 10px;
    }

    /deep/ .el-collapse-item__header {
        height: 40px;
        color: #fff;
        background-color: #1e4a7c;
    }
}
.el-table tr td{
  text-align: center;
}
</style>
